import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type DocumentDashboard } from '../../api/documents';

export function ComplianceDashboardPage() {
  const [dashboard, setDashboard] = useState<DocumentDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void documentsApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Compliance Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard && (
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          <MetricCard label="Retention Policies" value={dashboard.retention_policies} />
          <MetricCard label="Legal Holds" value={dashboard.legal_holds} />
          <MetricCard label="Archived Documents" value={dashboard.archived_documents} />
          <MetricCard label="Trashed Documents" value={dashboard.trashed_documents} />
        </div>
      )}
      <div className="mt-8 rounded-lg border p-4 text-sm dark:border-slate-700">
        <h2 className="font-medium">Compliance Features</h2>
        <ul className="mt-2 list-inside list-disc text-slate-600 dark:text-slate-400">
          <li>Retention policies enforce document lifecycle</li>
          <li>Legal hold prevents deletion of flagged documents</li>
          <li>Immutable audit trail for all document operations</li>
          <li>Chain of custody via version history</li>
        </ul>
      </div>
    </div>
  );
}

function MetricCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
      <p className="text-sm text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold">{value}</p>
    </div>
  );
}
